/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Marius Runde
 * Date: 19.07.2016
 *
 */
'use strict';
import L from 'external/leaflet';
import datefns from 'external/datefns';

const situationMapMeta = (situationMap, selectedVersions) => {
    return (`
                    <table>
                    <thead>
                        <tr>
                            <td><h5>Lagekarte: ${situationMap.title}</h5></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Version:</td>
                            <td>${situationMap.version}</td>
                        </tr>
                        <tr>
                            <td>Aktiv:</td>
                            <td>${situationMap.active ? 'Ja' : 'Nein'}</td>
                        </tr>
                       <tr>
                            <td>Geteilt:</td>
                            <td>${situationMap.shared ? 'Ja' : 'Nein'}</td>
                        </tr>
                        <tr>
                            <td>Ausgewählte Versionen:</td>
                        </tr>
                        ${
                            selectedVersions.map((item) => {
                                return (`
                                    <tr>
                                        <td>${item.version}</td>
                                        <td class="py-3">
                                        <p>Erstellt am: ${new Date(item.modifiedDate).toLocaleString()}</p>
                                        <p>Bearbeiter: ${item.userName}</p>
                                        <p>Beschreibung: ${item.description}</p>
                                        </td>
                                    </tr>
                                `);
                            })
                        }
                    </tbody>
                </table>
`)
}

export default class SituationMapPrintPlugin {

    constructor(props){
        this.init = this.init.bind(this);
        this.onPrint = this.onPrint.bind(this);
    }

    init(map, o){
        this.map = map;
        this.situationMaps = o.situationMaps;
        this.selectedSituationMapVersions = o.selectedSituationMapVersions;
        this.drawerGeoJSON = o.drawerGeoJSON || o.situationMapData;
        this.printControlTemplate = L.Control.extend({
            options: {
                position: 'topright'
            },

            onAdd: (map) => {
                this.container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
                this.icon = L.DomUtil.create('span', 'fa fa-print', this.container);

                this.container.setAttribute('title', 'Lagekarte drucken');
                this.container.setAttribute('role', 'button');

                L.DomEvent.on(this.container, 'click', this.onPrint, this);
                return this.container;
            }
        });
        this.printControl = new this.printControlTemplate();
        map.addControl(this.printControl);
    }

    onPrint(e){
        L.DomEvent.stopPropagation(e);
        L.DomEvent.preventDefault(e);
        if(!this.situationMaps || !this.selectedSituationMapVersions) {
            alert('Keine Lagekarte gefunden!');
            return;
        }

        const mapContainer = this.map.getContainer();
        const isFullscreen = mapContainer.classList.contains('leaflet-pseudo-fullscreen');
        const originalWidth = mapContainer.style.width;
        const originalHeight = mapContainer.style.height;
        const originalBounds = this.map.getBounds().pad(0.25);

        if (isFullscreen) {
            mapContainer.classList.remove('leaflet-pseudo-fullscreen');
        }
        mapContainer.style.width = 1240 + 'px';
        mapContainer.style.height = 1240 + 'px';
        this.map.fitBounds(originalBounds, { animate: false });
        this.map.invalidateSize(false);

        const prtContent = this.map._container.parentNode.cloneNode(true);
        prtContent.style.width = this.map._container.clientWidth + 'px';
        prtContent.style.height = this.map._container.clientHeight + 'px';
        const tiles = prtContent.getElementsByClassName('leaflet-tile');
        for (let tile of tiles) {
            tile.classList.add('leaflet-tile-loaded');
        }

        //reset original
        mapContainer.style.width = originalWidth;
        mapContainer.style.height = originalHeight;
        if (isFullscreen) {
            mapContainer.classList.add('leaflet-pseudo-fullscreen');
        }

        this.map.invalidateSize(false);
        this.map.fitBounds(originalBounds, { animate: false });

        const textMarkers = this.drawerGeoJSON && this.drawerGeoJSON.features && this.drawerGeoJSON.features.filter(f => f.properties.editFormData);
        let mapText = '';
        textMarkers && textMarkers.forEach((marker, i) => {
            mapText += `<li class="list-group-item">${i + 1}. ${marker.properties.editFormData.text}</li>`;
        });

        let controlContainer = prtContent.getElementsByClassName('leaflet-control-container')[0];
        const controls = Array.from(controlContainer.children).filter(node => node && !(node.classList.contains('leaflet-bottom') && node.classList.contains('leaflet-right')));
        for (const control of controls) {
            control.style = 'display: none;';
        }

        // canvas inside the cloned node are empty -> use original
        const original_cnavas = this.map._container.getElementsByTagName('canvas');
        Array.from(prtContent.getElementsByTagName('canvas')).forEach((canvasCopy, idx) => {
            const canvas = original_cnavas.item(idx);
            const img = new Image();
            img.src = canvas.toDataURL('image/png');
            img.style.cssText = canvas.style.cssText;
            img.classList = canvas.classList;
            canvasCopy.parentNode.replaceChild(img, canvasCopy);
        });

        const head = document.head.cloneNode(true);
        Array.from(head.getElementsByTagName('script')).forEach(tag => {
            tag.parentNode.removeChild(tag);
        });
0
        const html = `
            ${head.innerHTML}
            <body style="-webkit-print-color-adjust: exact;color-adjust: exact;">
                <div class="py-3 d-flex" style="gap:3.5rem;">
                ${
                    this.situationMaps.item.reduce((acc, situationMap) => {
                        const selectedVersions = this.selectedSituationMapVersions.filter(v => v.situationMapId === situationMap.id);
                        if(selectedVersions.length > 0) {
                            acc += situationMapMeta(situationMap, selectedVersions)
                        }
                        return acc;
                    }, '')
                }
                </div>
                <div>
                    <h5>Textelemente</h5>
                    <ul class="list-group m-0">
                       ${mapText || '<li class="list-group-item">---</li>'}
                    </ul>   
                </div>
                ${prtContent.innerHTML}
                <footer class="p-3">
                     ${datefns.format(new Date(), 'dd.MM.yy HH:mm')} Uhr, ${window.themeDisplay.getUserName()}
                </footer>
                <script>
                    window.onload = function() {
                        window.print();
                    };
                </script>
            </body>
        `;
        const WinPrint = window.open('', 'FLIWAS-Karte');
        WinPrint.document.write(html);
        WinPrint.document.close();
        WinPrint.focus();

        WinPrint.onafterprint = function (event){
            WinPrint.close();
        };
    }

}



// WEBPACK FOOTER //
// ./js/plugins/SituationMapPrintPlugin.js